module.exports = __webpack_public_path__ + "img/logo-lifefitness.c06371c.svg";